// @flow

import { getReducer } from '../selectors';
import { getDiscountPrice } from '../../pdb/selectors';
import { getActivePdbId } from '../../pdb';
import type { Cart, CartGroups, CartPrice } from './types';
import type { State } from '../types';
import type { State as PdbState } from '../../pdb/types';
import type { State as RouterState } from '../../router/types';

type GlobalState = {
  configuration: State,
  pdb: PdbState,
  router: RouterState,
};

export const getCart = (state: GlobalState, pdbId?: ?string): ?Cart => {
  const selectedPdbId = pdbId || getActivePdbId(state);
  if (selectedPdbId) {
    return getReducer(state).cart[selectedPdbId];
  }
  return null;
};

export const getCartGroups = (state: GlobalState, pdbId?: ?string): ?CartGroups => {
  const cart = getCart(state, pdbId);
  return cart ? cart.groups : null;
};

export const getCartGroupsPrice = (state: GlobalState, pdbId?: ?string): ?CartPrice => {
  const cart = getCart(state, pdbId);
  return cart ? cart.groupsPrice : null;
};

export const getCartBasePrice = (state: GlobalState, pdbId?: ?string): CartPrice => (
  getDiscountPrice(state, pdbId)
);

export const getCartPrice = (state: GlobalState, pdbId?: ?string): CartPrice => (
  getCartGroupsPrice(state, pdbId) + getCartBasePrice(state, pdbId)
);

export default null;
